import {
	CHANGE_PARITY_USER_TO_REV_HERO_USER_MUTATION,
	CHANGE_PASSWORD_MUTATION,
	FIND_PROFILE_INTERCOM_HASH,
	FIND_PROFILE_QUERY,
	RESET_PASSWORD_MUTATION,
	RESET_PASSWORD_REQUEST_MUTATION,
	SAVE_PROFILE_MUTATION,
} from '@app/model/profile/service/ProfileGraphQLQueries';
import Profile from '@app/model/profile/Profile';
import Return from '@app/model/_common/Return';
import ProfileInput from '@app/model/profile/input/ProfileInput';
import ChangePasswordInput from '@app/model/profile/input/ChangePasswordInput';

import ResetPasswordInput from '@app/model/profile/input/ResetPasswordInput';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import Principal from '@app/model/authentication/Principal';


class ProfileService {
	public static findProfile() {
		return GraphQLExecutor.execute<Profile>(FIND_PROFILE_QUERY);
	}

	public static findIntercomHash() {
		return GraphQLExecutor.execute<string>(FIND_PROFILE_INTERCOM_HASH);
	}

	public static saveProfile(input: ProfileInput) {
		return GraphQLExecutor.execute<Principal>(SAVE_PROFILE_MUTATION, { input });
	}

	public static changePassword(input: ChangePasswordInput) {
		return GraphQLExecutor.execute<Return>(CHANGE_PASSWORD_MUTATION, { input });
	}

	public static resetPasswordRequest(email: string) {
		return GraphQLExecutor.execute<Return>(RESET_PASSWORD_REQUEST_MUTATION, { email });
	}

	public static resetPassword(input: ResetPasswordInput) {
		return GraphQLExecutor.execute<Return>(RESET_PASSWORD_MUTATION, { input });
	}

	public static changeParityUserToRevHeroUser(code: string) {
		return GraphQLExecutor.execute<Principal>(CHANGE_PARITY_USER_TO_REV_HERO_USER_MUTATION, { code });
	}
}

export default ProfileService;